<div [ngSwitch]="isEmailSent" style="padding: 3rem;">

  <div
    *ngSwitchCase="false"
    style="padding:1rem; display: flex; flex-direction: column; justify-content: space-between">
    <h2 mat-dialog-title *ngIf="!isEnd">Cambia Email</h2>

    <div>
      <div >
        <p>Inserisci la nuova email:</p>
      </div>
    </div>

    <div>
      <form (ngSubmit)="change_user()" [formGroup]="form" novalidate>
        <br>
        <mat-form-field appearance="outline">
          <mat-label>Indirizzo email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            autocomplete="email"
            placeholder="Inserisci la tua email"
            required
          />
        </mat-form-field>
        <br>
        <br>
        <div style="width: 100%; display: flex; flex-direction: column; justify-content: center;align-items: center;">
          <button
            class="btn btn-pollstar btn-pollstar-fullwidth btn-gradient-orange"
            type="submit"
            [disabled]="isLoading"
          >
            <span [hidden]="!isLoading"><i class="fas fa-cog fa-spin" ></i></span>
            <span>&nbsp;</span>
            <span translate>Invia</span>
          </button>
        </div>
      </form>
      <br>
    </div>
  </div>

  <ng-container *ngSwitchCase="true">
    <div>
      <strong>Email inviata</strong>
      <p>Ti abbiamo inviato un'email al tuo <strong>NUOVO</strong> indirizzo.</p>
      <p>Per rendere effettiva questa modifica, segui le istruzioni presenti nell'email che hai ricevuto.</p>
      <br>
      <strong>Attenzione</strong>
      <p>Portai utilizzare il tuo nuovo indirizzo email solo dopo aver completato l'intera procedura.</p>
      <p>
        Questa misura di sicurezza è necessaria per verificare che l'indirizzo email da te inserito sia realmente in tuo possesso.
      </p>
      <br>
      <strong >Non hai ricevuto l’email?</strong>
      <p>
      <span>
        Verifica se nella cartella dello spam è presente un’email da
        pollstar@email.com. Se non riesci a visualizzare l’email, inviaci
        un messaggio utilizzando il form presente nella pagina
      </span>
        <span>&nbsp;</span>
        <a [routerLink]="['contact-us']">Contatti.</a>
      </p>
    </div>
    <br>
  </ng-container>

</div>
